"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = genericSubject;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _rxjs = require("rxjs");

var _store = _interopRequireDefault(require("store"));

var _item = _interopRequireDefault(require("../options/item"));

var _development = _interopRequireDefault(require("./development"));

// Copyright 2017-2019 @polkadot/ui-keyring authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.
function callNext(current, subject, withTest) {
  const isDevMode = _development.default.isDevelopment();

  subject.next(Object.keys(current).reduce((filtered, key) => {
    const _current$key$json = current[key].json,
          _current$key$json2 = _current$key$json === void 0 ? {} : _current$key$json,
          _current$key$json2$me = _current$key$json2.meta,
          _current$key$json2$me2 = _current$key$json2$me === void 0 ? {} : _current$key$json2$me,
          _current$key$json2$me3 = _current$key$json2$me2.isTesting,
          isTesting = _current$key$json2$me3 === void 0 ? false : _current$key$json2$me3;

    if (!withTest || isDevMode || isTesting !== true) {
      filtered[key] = current[key];
    }

    return filtered;
  }, {}));
}

function genericSubject(keyCreator) {
  let withTest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  let current = {};
  const subject = new _rxjs.BehaviorSubject({});

  const next = () => callNext(current, subject, withTest);

  _development.default.subject.subscribe(next);

  return {
    add: (address, json) => {
      current = (0, _objectSpread2.default)({}, current);
      current[address] = {
        json,
        option: (0, _item.default)(address, json.meta.name, !json.meta.isRecent)
      };

      _store.default.set(keyCreator(address), json);

      next();
      return current[address];
    },
    remove: address => {
      current = (0, _objectSpread2.default)({}, current);
      delete current[address];

      _store.default.remove(keyCreator(address));

      next();
    },
    subject
  };
}